module.exports = __webpack_public_path__ + "static/media/Inclined-Kids1.27807217.gif";